// Detects icon names whose glyph physically points left/right and therefore needs to be
// mirrored under RTL (`rtl:-scale-x-100`). Matches icon families like arrow/chevron/caret/
// back/next/prev/previous/forward that end in "-left" or "-right" (optionally followed by
// more segments, e.g. `chevron-big-right-circle-outlined`). Icons that merely contain "left"
// or "right" without one of those keyword prefixes (e.g. `panel-left-open`, `corner-up-left`)
// are NOT directional — they don't visually point a horizontal direction.
const DIRECTIONAL_ICON_KEYWORDS_PATTERN =
  /(^|[-:])(arrow|chevron|caret|back|next|prev|previous|forward)([-a-z]*)-(left|right)($|-)/;
const SIMPLE_DIRECTIONAL_ICON_PATTERN = /^(arrow|chevron)-(left|right)/;

export const isDirectionalIcon = (name: string): boolean =>
  DIRECTIONAL_ICON_KEYWORDS_PATTERN.test(name) || SIMPLE_DIRECTIONAL_ICON_PATTERN.test(name);
